import { defineStore } from 'pinia'

export const useDialerStore = defineStore('dialer', {
  state: () => ({
    show: false,
    contact: null,
  }),

  actions: {
    openDialer(contact = null) {
      this.contact = contact
      this.show = true
    },

    closeDialer() {
      this.show = false
      // Keep contact info for a moment in case of redial
      // It will be cleared on next openDialer call
    },

    clearContact() {
      this.contact = null
    },
  },

  getters: {
    phoneNumber: (state) => {
      if (!state.contact) return ''
      return state.contact.phone || state.contact.phone_number || ''
    },

    contactName: (state) => {
      if (!state.contact) return ''
      return state.contact.name || state.contact.first_name || ''
    },

    contactUserId: (state) => {
      if (!state.contact) return null
      return state.contact.id || state.contact.user_id || null
    },
  },
})
